// Import all offer page related scripts
import { closeModalButton } from '@atoms/close-modal-button';
import { contentToggle } from '@atoms/content-toggle';
import { extendableOfferButton } from '@components-molecules/extendable-offer-button';
import { GoogleMapCustom } from '@molecules/google-map';
import { Cookie } from '@tools/cookie';
import { eventBus } from '@tools/event-bus';
import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';
import { offerDetails } from './details';
import { googleMapStatic } from './google-map-static';
import { officeConfiguratorLauncher } from './multioffice/office-configurator-launcher';
import { offerFavoriteButton } from './offer-favorite-button';
import { offerProposalButton } from './offer-proposal-button';
import { initializeRefuseProposalButton, initSelectionItemRemoveListener } from './offer-refuse-proposal-button';

export const initOfferMain = () => {
  // start configurator before wrapper as wrapper will receive
  // events from configurator during `mounted` lifecycle hook
  if (document.getElementById('multioffice-configurator')) {
    officeConfiguratorLauncher('#multioffice-configurator');
  }

  offerDetails();

  // Text description will be toggled if its height > 200
  contentToggle(
    document.querySelector('.offer-description.content-toggle'),
    200,
  );
  const SEEN_OFFERS_COOKIE_NAME = 'seen_offers';
  const showMobileContactForm = () => {
    document.getElementsByClassName('ods__contact')[0].style.display = 'flex';
    if (window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet) {
      document.body.classList.toggle('no-scroll');
    }
  };

  const contactMobileButtons = document.querySelectorAll('.mobile-contact-offer-cta');
  contactMobileButtons.forEach((btn) => {
    btn.addEventListener('click', showMobileContactForm);
  });

  const closeContactIcon = document.querySelector('.ods__contact--close');
  if (closeContactIcon) {
    closeModalButton(closeContactIcon, document.querySelector('.ods__contact'));
  }

  const inputs = document.querySelectorAll('.ods__contact input');
  inputs.forEach((input) => {
    input.addEventListener('focus', () => {
      document.querySelector('.ods__tos').style.display = 'initial';
    });
  });
  window.addEventListener('load', () => {
    const mapScript = document.getElementById('__googleMapsScriptId');

    const script = mapScript || googlePlacesHelpers.initLib();
    script.addEventListener('load', () => {
      document.querySelectorAll('[data-google-map-static="on"]').forEach(
        (el) => googleMapStatic(el),
      );

      document.querySelectorAll('[data-google-map-static-button="on"]').forEach((el) => {
        const map = new GoogleMapCustom(el);
        map.renderStatic();
      });
    });
    const seenOffers = Cookie.get(SEEN_OFFERS_COOKIE_NAME) ? JSON.parse(Cookie.get(SEEN_OFFERS_COOKIE_NAME)) : [];
    seenOffers.push(window.initialAppState.offer_id.toString());
    Cookie.setJSON(SEEN_OFFERS_COOKIE_NAME, [ ...new Set(seenOffers) ]);
  });

  document.querySelectorAll('[data-offer-favorite-button="on"]').forEach(
    (button) => offerFavoriteButton(button),
  );

  document.querySelectorAll('[data-offer-proposal-button="on"]').forEach(
    (button) => offerProposalButton(button),
  );

  document.querySelectorAll('[data-offer-refuse-proposal-button="on"]').forEach(
    (button) => initializeRefuseProposalButton(button),
  );

  const refuseProposalButton = document.querySelector('[data-offer-refuse-proposal-button="on"]');
  if (refuseProposalButton) {
    initSelectionItemRemoveListener();
  }

  // Share button with copy to clipboard feature
  const shareButtonContainer = document.querySelector('.offer-details [data-share-button="on"]');
  if (shareButtonContainer) {
    extendableOfferButton(shareButtonContainer);
  }

  document.querySelectorAll('.virtualvisit-launcher').forEach(
    (element) => element.addEventListener(
      'click',
      () => eventBus.dispatchEvent(new Event('virtualvisit-open')),
    ),
  );
};
